<template>
  <BreadCrumb PageTitle="Gallery" />
  <GalleryContent />
  <GalleryTwo />
  <GalleryThree />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import GalleryContent from "../../template-components/PagesInner/Gallery/GalleryContent.vue";
import GalleryTwo from "../../template-components/PagesInner/Gallery/GalleryTwo.vue";
import GalleryThree from "../../template-components/PagesInner/Gallery/GalleryThree.vue";

export default defineComponent({
  name: "GalleryPage",
  components: {
    BreadCrumb,
    GalleryContent,
    GalleryTwo,
    GalleryThree,
  },
});
</script>